/**
 * Root mutations for the entire applications
 */

import { ROOT_MUTATION_TYPES } from "./mutation-types";
import { getDefaultState } from "./state";

export default {
  [ROOT_MUTATION_TYPES.SAVE_USER](state, user) {
    state.user = user;
  },

  [ROOT_MUTATION_TYPES.SAVE_USER_ROLES](state, roles) {
    state.userRoles = roles;
  },

  [ROOT_MUTATION_TYPES.SAVE_ACCESS_TOKEN](state, accessToken) {
    state.accessToken = accessToken;
  },

  [ROOT_MUTATION_TYPES.SAVE_REFRESH_TOKEN](state, refreshToken) {
    state.refreshToken = refreshToken;
  },

  [ROOT_MUTATION_TYPES.TOGGLE_SIDEBAR](state) {
    state.sidebarOpen = !state.sidebarOpen;
  },

  [ROOT_MUTATION_TYPES.SAVE_PORTS](state, ports) {
    state.ports = {
      loaded: true,
      data: ports
    };
  },

  /**
   * Reset the root state
   * @param {*} state
   */
  [ROOT_MUTATION_TYPES.RESET_STATE](state) {
    Object.assign(state, getDefaultState());
  }
};
